const prodAPI = 'https://certiservices.azurewebsites.net/';
const localAPI = 'http://localhost:52646/';
const apiRef = prodAPI;
export const certiCoreBaseUrl = 'https://certicore.azurewebsites.net';
export const certiSystemsBaseUrl = 'https://systems.certinergie.be';
export const certiServicesBaseUrl = 'https://certiservices.azurewebsites.net';
export const certiItOrderConnectorBaseUrl =
  'https://as-certiit-order-connector-api-prod-aqeseucpcfh9fabk.germanywestcentral-01.azurewebsites.net/';

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAC3LGik6S0kYASfaAYMbcVUz5pxXXOj0s',
    authDomain: 'certimmo-930d3.firebaseapp.com',
    databaseURL: 'https://certimmo-930d3.firebaseio.com',
    projectId: 'certimmo-930d3',
    storageBucket: 'certimmo-930d3.appspot.com',
    messagingSenderId: '12993987359',
    appId: '1:12993987359:web:d3ce9ea6979c978c5e662a',
    measurementId: 'G-Z0C2QXWZH5'
  },
  release: '20260922.4',
  stripeCheckoutUrl: 'https://certinergie-stripe-prod.azurewebsites.net/api/checkout-session',
  stripeGetStatusUrl: 'https://certinergie-stripe-prod.azurewebsites.net/api/session-status',
  stripePublicKey: 'pk_live_RPnzJ2n7aIxtPjVP0zVoF9Z3',
  stripePublicKeyGreenfish: 'pk_live_k19XEZCDlk91w5cGmg2333HH00WzFL3USj',
  API: {
    SEND_BROCHURE: apiRef + 'api/notary/plaquette/sendmails'
  },
  CertiCore: {
    userOrdersUrl: certiCoreBaseUrl + '/api/v1/espaceclient/users/me/orders/',
    loginUrl: certiCoreBaseUrl + '/api/v1/espaceclient/auth/login/',
    resetPassword: certiCoreBaseUrl + '/api/v1/espaceclient/auth/resetpassword',
    refreshToken: certiCoreBaseUrl + '/api/v1/espaceclient/auth/refreshtoken/',
    orderInfo: certiCoreBaseUrl + '/api/v1/espaceclient/orders/',
    publicOrderInfo: certiCoreBaseUrl + '/api/v1/espaceclient/orders/anonymous/',
    publicOrderInfoV2: certiCoreBaseUrl + '/api/v2/espaceclient/orders/anonymous/',
    askActeToTrue: certiCoreBaseUrl + '/api/v1/espaceclient/orders/{orderId}/askacte',
    agreeToPay: certiCoreBaseUrl + '/api/v1/espaceclient/orders/{orderId}/agreetopay',
    notifications: certiCoreBaseUrl + '/api/v1/users/me/notifications',
    getUserInfo: certiCoreBaseUrl + '/api/v1/espaceclient/auth/me/',
    refreshUserInfo: certiCoreBaseUrl + '/api/v1/espaceclient/auth/me/',
    deleteNotifications: certiCoreBaseUrl + '/api/v1/users/me/notifications?orderId={orderId}',
    getElecAgents: certiCoreBaseUrl + '/api/v1/espaceclient/users/employees/elec',
    checkVat: certiCoreBaseUrl + '/api/v1/helpers/vat',
    agendaEmployees: certiCoreBaseUrl + '/api/v1/espaceclient/users/employees/elec/',
    sendDocReminder: certiCoreBaseUrl + '/api/v1/espaceclient/comments/rappel/',
    checkoutInfo: certiCoreBaseUrl + '/api/v1/espaceclient/orders/{orderId}/checkout',
    checkoutInfoV2: certiCoreBaseUrl + '/api/v2/espaceclient/orders/{orderId}/checkout',
    clientComment: certiCoreBaseUrl + '/api/v1/espaceclient/comments/public/',
    sms: certiCoreBaseUrl + '/api/v1/sms',
    forgotPassword: certiCoreBaseUrl + '/api/v1/espaceclient/auth/forgotpassword',
    sendOrderFeedback: certiCoreBaseUrl + '/api/v1/espaceclient/orders/anonymous/orderRating',
    getCompanyEmployee: certiCoreBaseUrl + '/api/v1/espaceclient/companyemployees/{companyEmployeeId}'
  },
  CertiSystems: {
    onlineAgendaUrl: certiSystemsBaseUrl + '/api/onlineagenda',
    loginWeb: certiSystemsBaseUrl + '/api/LoginWeb',
    mailSending: certiSystemsBaseUrl + '/api/mailsending',
    emailWithTemplate: certiSystemsBaseUrl + '/api/EmailWithTemplate',
    packPromo: certiSystemsBaseUrl + '/api/PackPromo',
    createNewUser: certiSystemsBaseUrl + '/api/CreateNewUser',
    orderInfo: certiSystemsBaseUrl + '/api/orderinfo'
  },
  CertiServices: {
    order: certiServicesBaseUrl + '/api/Order',
    primmo: certiServicesBaseUrl + '/api/primmo'
  },
  CertiItOrderConnector: {
    URL: certiItOrderConnectorBaseUrl,
    API_KEY: 'R6df2r83F21z4F8g97T49gBE0B1e5Tk61',
    checkDuplicate: certiItOrderConnectorBaseUrl + '/api/orders/checkduplicate'
  },
  PlanningApiMicroservice: {
    URL:
      'https://as-certiit-microservice-planning-api-prod-b4g4fbh0h0ebbree.germanywestcentral-01.azurewebsites.net/api',
    API_KEY: '8fd5R5GsD45v9N3d21j63yfD5sE98W45d',
    ESTIMATED_PLANNING_PROCESS_MAX_TIME: 2000
  },
  OrderConnector: {
    URL: 'https://as-certiit-order-connector-api-prod-aqeseucpcfh9fabk.germanywestcentral-01.azurewebsites.net/api', // TODO: add production URL when available
    API_KEY: 'R6df2r83F21z4F8g97T49gBE0B1e5Tk61'
  },
  baseUrl: 'https://order.certinergie.be',
  certinergieBlobStorageBaseUrl: 'https://certinergie.blob.core.windows.net',
  certinergieNotaryAppBaseUrl: 'https://notary.certinergie.be',
  certiAdminBaseUrl: 'https://certiadmin.azurewebsites.net',
  googleMapsApiKey: 'AIzaSyBXzjjPS9asB2iK_wl-ZcMhRc7RLBEUS18',
  geocodingServiceUrl: certiCoreBaseUrl + '/api/v1/espacecertif/geocode'
  // AgmCoreModule.forRoot({
  //   apiKey: 'AIzaSyBXzjjPS9asB2iK_wl-ZcMhRc7RLBEUS18',
  //   libraries: ['places']
  // }),
};
